import Vue from 'vue'


import App from '@/App.vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)


const Foo = { template: '<div>foo</div>' }
const Bar = { template: '<div>bar</div>' }

const routes = [
  { path: '/foo', component: Foo },
  { path: '/bar', component: Bar }
]
const router = new VueRouter({
  routes // short for `routes: routes`
})

Vue.config.productionTip = false

new Vue({
  
  render: h => h(App),
  router,
}).$mount('#app')






let nav_list_container=document.querySelector('.nav-list-container')

let close_menu=document.querySelector('.close-menu')
let bouton=document.querySelector('.bout2')
let items=document.querySelectorAll('.nav-item')

 

let cli5=function()
{
    if(!bouton.classList.contains('cliked_menu2')){
bouton.classList.add('cliked_menu2');
// body.classList.add('overflowY-hidden')
close_menu.classList.remove('display-none')
nav_list_container.style.visibility="visible"


}
     else{
        bouton.classList.remove('cliked_menu2');
        close_menu.classList.add('display-none')
        // nav_list_container.style.display="none"
        nav_list_container.style.visibility="hidden"
        // body.classList.add('overflowY-scroll')
     }
};
bouton.addEventListener('click',cli5);


//Nav item click on mobile phone

items.forEach(element => {


element.addEventListener('click',function(){

  if(bouton.classList.contains('cliked_menu2')){
    bouton.classList.remove('cliked_menu2');
    close_menu.classList.add('display-none');
    nav_list_container.style.visibility="hidden"
    // body.classList.add('overflowY-scroll')
  }

})


});


close_menu.addEventListener('click',function () {
    if(bouton.classList.contains('cliked_menu2')){
     bouton.classList.remove('cliked_menu2');
        close_menu.classList.add('display-none')
        // nav_list_container.style.display="none"
        nav_list_container.style.visibility="hidden"
        // body.classList.add('overflowY-scroll')
    }
    })

    //nav bar gesture in responsive mode

      let windowWidth
      window.addEventListener('resize',function () {        
       windowWidth = window.innerWidth;

        if(windowWidth<983){
            nav_list_container.style.visibility="hidden"
            if(bouton.classList.contains('cliked_menu2')){
                nav_list_container.style.visibility="visible"
            }
        }
        else{
            nav_list_container.style.visibility="visible" 

        }

      })

      var onLoadWidth=window.innerWidth;

      if(onLoadWidth<983){
        nav_list_container.style.visibility="hidden"  
      }


// scroll effect in footer

      var foot=document.querySelector('.footer')

      var lineFooter=document.querySelectorAll('.line-footer')
      var thanks=document.querySelector('.thanks')
      var thanks2=document.querySelector('.thanks2')
      var middleFooterStart=document.querySelector('.middle-footer-start')

      window.addEventListener('scroll',scroly)
      function scroly() {
        
        if(!close_menu.classList.contains('display-none')){
          if(window.scrollY>0){
            bouton.classList.remove('cliked_menu2');
            close_menu.classList.add('display-none')
            nav_list_container.style.visibility="hidden"
           
          }
        }

        if(foot.getBoundingClientRect().top<500){
            if(!thanks.classList.contains('show-thanks')){
                lineFooter[0].classList.add('show-footer-line')
                lineFooter[1].classList.add('show-footer-line')
                thanks.classList.add('show-thanks')
                thanks2.classList.add('show-thanks2')
                middleFooterStart.classList.add('show-footer-star')
            }


        }
        
          
      }
      // document.getElementById('contact-form').addEventListener('submit',function(){
      //   console.log("hello")
      // })

      //contact form
  // Your web app's Firebase configuration

  // var firebaseConfig = {
  //   apiKey: "AIzaSyAM5u4Aq6rqrX9ErX2t6oCgV8nBcxdDao8",
  //   authDomain: "portofoliodata.firebaseapp.com",
  //   databaseURL: "https://portofoliodata.firebaseio.com",
  //   projectId: "portofoliodata",
  //   storageBucket: "portofoliodata.appspot.com",
  //   messagingSenderId: "949822654171",
  //   appId: "1:949822654171:web:7b5dba4b047191768b6efe",
  //   measurementId: "G-WN9R51P77R"
  // };
  // // Initialize Firebase
  // firebase.initializeApp(firebaseConfig);
 
//   var alert_message_sent=document.querySelector('.message-sent')
//   var alert_message_not_sent=document.querySelector('.message-not-sent')

//   document.getElementById('contact-form').addEventListener('submit',submitMessage)


//   var nameCont=document.getElementById('name')
//    var emailCont=document.getElementById('email')
//    var messageCont=document.getElementById('message')

//   function submitMessage(e) {
//     e.preventDefault()
// var name=nameCont.value
// var email=emailCont.value
// var message=messageCont.value

//    if(name!=null&&email!=null&&message!=null){
//      if(name.length!=0&&email.length!=0&&message.length!=0){
//           if(name.length>=4){
//             if(message.length>=5){
//           saveMessage(name,email,message)
//           nameCont.setAttribute("value","")
//           messageCont.setAttribute("value","")
//           emailCont.setAttribute("value","")
//           }else{
//             alert_message_not_sent.classList.remove('display-none') 
//           }
//         }else{
//           alert_message_not_sent.classList.remove('display-none') 
//         }

//      }
//      else{
//       alert_message_not_sent.classList.remove('display-none')    
//      }
//    }
//    else{
//     alert_message_not_sent.classList.remove('display-none')
//    }
//   }

//   // function getInputValue(id) {
//   //   return document.getElementById(id).value
//   // }


// //save messages function
//   function saveMessage(name,email,message) {

//     db.collection("messages").add({
//       name: name,
//       email: email,
//       message: message
//   }).then(function() {

//       alert_message_sent.classList.remove('display-none')
//   })
//   .catch(function() {
//     alert_message_not_sent.classList.remove('display-none')
      
//   });
//   }


